// src/pages/HomePage.js
import React from 'react';
import { Helmet } from 'react-helmet-async';

// Import all section components
import Hero from '../components/Hero';
import SocialProof from '../components/SocialProof';
import ProblemSolution from '../components/ProblemSolution';
import FeatureShowcase from '../components/FeatureShowcase';
import ValueProps from '../components/ValueProps';
import Testimonials from '../components/Testimonials';
import PricingPreview from '../components/PricingPreview';
import MiniToolsPreview from '../components/MiniToolsPreview'; // ✅ Import the new component
import BlogPreview from '../components/BlogPreview';
import FAQ from '../components/FAQ';
import FinalCTA from '../components/FinalCTA';

// The SEO component remains page-specific
const SEO = ({ title, description, pathname }) => (
  <Helmet>
    <title>{title}</title>
    <meta name="description" content={description} />
    <link rel="canonical" href={`https://oolook.in${pathname}`} />
  </Helmet>
);

const HomePage = () => {
  return (
    <>
      <SEO
        title="Oolook — Your AI Co-pilot for Social Media Management"
        description="Oolook automates your content creation, scheduling, and analytics, so you can focus on growth. Tame the social media chaos."
        pathname="/"
      />
      <main className="bg-dark-bg text-dark-text-secondary font-sans animate-fade-in">
        
        {/* The Aurora Background is a page-level effect, so it stays here */}
        <div className="absolute top-0 left-0 w-full h-screen bg-gradient-to-r from-sky-500/20 via-cyan-400/10 to-transparent opacity-30 animate-aurora" style={{ backgroundSize: '400% 400%' }} />
        
        <div className="relative isolate">
          <Hero />
          <SocialProof />
          <ProblemSolution />
          <FeatureShowcase />
          <ValueProps />
          <Testimonials />
          <PricingPreview />
          <MiniToolsPreview /> {/* ✅ Add the new component here */}
          <BlogPreview />
          <FAQ />
          <FinalCTA />
        </div>
      </main>
    </>
  );
};

export default HomePage;